<mat-card>
  <h1>优惠码 <span (click)="openModal()">查看优惠码</span></h1>
  <div class="input">
    <input matInput placeholder="请输入优惠码" [(ngModel)]="code" />
    <button mat-flat-button color="primary" (click)="onOk()">确定</button>
  </div>
  <div class="tip">
    <div class="left">下单使用优惠码享<span>95折</span>优惠</div>
    <div>仅限新用户注册且未下单的用户使用</div>
  </div>
</mat-card>
